var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditfilledicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.518 7.58317C11.9794 6.92179 12.2499 6.11737 12.2499 5.24984C12.2499 2.99468 10.4218 1.1665 8.16659 1.1665C5.91142 1.1665 4.08325 2.99467 4.08325 5.24984C4.08325 5.8761 4.22424 6.46941 4.4762 6.99984",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49375 4C9.56623 4 9.625 3.95802 9.625 3.90625V3.59375C9.625 3.54198 9.56623 3.5 9.49375 3.5H6.25625C6.18377 3.5 6.125 3.54198 6.125 3.59375V3.94334C6.125 3.99512 6.18377 4.03709 6.25625 4.03709H7.189C7.48768 4.03709 7.71685 4.11489 7.85586 4.25H6.25625C6.18377 4.25 6.125 4.29198 6.125 4.34375V4.65625C6.125 4.70802 6.18377 4.75 6.25625 4.75H7.99265C7.92466 5.03192 7.63214 5.20806 7.175 5.20806H6.25625C6.18377 5.20806 6.125 5.25004 6.125 5.30181V5.71597C6.125 5.74213 6.14031 5.76711 6.16723 5.78486L7.97249 6.97514C7.99673 6.99112 8.02851 7 8.06151 7H8.96453C9.08401 7 9.14134 6.89525 9.05355 6.83736L7.40328 5.74927C8.23998 5.73098 8.83766 5.33212 8.91613 4.75H9.49375C9.56623 4.75 9.625 4.70802 9.625 4.65625V4.34375C9.625 4.29198 9.56623 4.25 9.49375 4.25H8.85183C8.8137 4.15984 8.76127 4.0762 8.69595 4H9.49375Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.1665H3.14698C3.31857 8.1665 3.4878 8.20518 3.64127 8.27944L4.83242 8.85577C4.98589 8.93003 5.15512 8.96865 5.32671 8.96865H5.93489C6.52313 8.96865 7 9.43012 7 9.99934C7 10.0223 6.98425 10.0426 6.96138 10.0489L5.47917 10.4587C5.21329 10.5322 4.92858 10.5066 4.68125 10.3869L3.4079 9.77085M7 9.62484L9.67913 8.8017C10.1541 8.6537 10.6675 8.82917 10.965 9.24118C11.1801 9.53903 11.0925 9.96562 10.7791 10.1465L6.39503 12.676C6.11619 12.8368 5.78722 12.8761 5.48051 12.7851L1.75 11.6781",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_1344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    fill: "white",
    transform: "translate(5.25 2.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditfilledicon);
export default __webpack_public_path__ + "static/media/creditfilledicon.978cbb9fa892b924bb634a8a25e8600a.svg";
export { ForwardRef as ReactComponent };